import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactKeyboard extends EventRegistryCategory {
    label = 'Keyboard Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    keydown = () => new EventRegistryItem({ handlerName: 'onKeyDown' });
    keypress = () => new EventRegistryItem({ handlerName: 'onKeyPress' });
    keyup = () => new EventRegistryItem({ handlerName: 'onKeyUp' });
}
